import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Batteria56VConstantPoweriEf({ idVariant = '', className }: Props) {
  return (
    <IconBase name="batteria56-v-constant-poweri-ef" w={65.617} h={65.619} className={className}>
      <g transform="translate(-38 -39.112)">
        <g>
          <defs>
            <rect
              id={`batteria56vconstantpowerief_${idVariant}_SVGID_1_`}
              x="38"
              y="39.112"
              width="65.617"
              height="65.619"
            />
          </defs>
          <clipPath id={`batteria56vconstantpowerief_${idVariant}_SVGID_2_`}>
            <use
              xlinkHref={`#batteria56vconstantpowerief_${idVariant}_SVGID_1_`}
              overflow="visible"
            />
          </clipPath>
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#9D9D9C"
            d="M71.587,104.73c17.69,0,32.03-14.34,32.03-32.031
      		c0-17.689-14.34-32.03-32.03-32.03s-32.03,14.341-32.03,32.03C39.558,90.391,53.897,104.73,71.587,104.73"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#E3E5E8"
            d="M70.03,103.174c17.691,0,32.031-14.342,32.031-32.031
      		c0-17.69-14.34-32.031-32.031-32.031C52.34,39.112,38,53.453,38,71.143C38,88.832,52.34,103.174,70.03,103.174"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M43.01,71.689c0,14.948,12.161,27.11,27.109,27.11
      		c0.941,0,1.881-0.053,2.815-0.15l1.343,3.891c0.097,0.283,0.356,0.439,0.618,0.439c0.178,0,0.357-0.072,0.491-0.225l7.317-8.432
      		c0.463-0.531,0.176-1.367-0.519-1.502l-10.959-2.125c-0.044-0.008-0.086-0.012-0.127-0.012c-0.433,0-0.763,0.432-0.614,0.865
      		l1.245,3.611c-0.535,0.035-1.073,0.059-1.611,0.059c-12.973,0-23.529-10.555-23.529-23.53c0-12.109,9.197-22.108,20.972-23.388
      		v-3.597C53.809,45.998,43.01,57.604,43.01,71.689"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#E3E5E8"
            d="M50.176,71.667c0,10.664,8.411,19.396,18.946,19.917
      		c-0.062-0.49,0.059-0.994,0.351-1.406c0.375-0.525,0.983-0.838,1.624-0.838c0.128,0,0.258,0.012,0.385,0.035l5.416,1.051
      		c1.387-0.5,2.719-1.154,3.973-1.959c5.756-3.691,9.192-9.973,9.192-16.8c0-10.997-8.946-19.942-19.943-19.942
      		C59.124,51.724,50.176,60.669,50.176,71.667"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#FFFFFF"
            d="M74.311,57.633h-8.38c-1.44,0-2.613,1.172-2.613,2.613v25.632
      		c0,1.439,1.173,2.613,2.613,2.613h8.38c1.439,0,2.612-1.174,2.612-2.613V60.247C76.923,58.805,75.75,57.633,74.311,57.633"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M76.922,85.879c0,1.438-1.172,2.611-2.612,2.611h-8.378
      		c-1.441,0-2.613-1.174-2.613-2.611V60.247c0-1.44,1.172-2.613,2.613-2.613h8.378c1.44,0,2.612,1.173,2.612,2.613V85.879z
      		 M74.31,56.837h-0.396c0.016-0.05,0.032-0.101,0.032-0.155v-1.746c0-0.304-0.249-0.552-0.554-0.552h-6.545
      		c-0.305,0-0.553,0.248-0.553,0.552v1.746c0,0.055,0.016,0.105,0.031,0.155h-0.394c-1.88,0-3.41,1.529-3.41,3.409v25.632
      		c0,1.879,1.53,3.408,3.41,3.408h8.378c1.88,0,3.409-1.529,3.409-3.408V60.247C77.719,58.367,76.189,56.837,74.31,56.837"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M65.011,82.24v2.883c0,0.791,0.648,1.439,1.438,1.439h7.342
      		c0.791,0,1.438-0.648,1.438-1.439V82.24c0-0.791-0.647-1.439-1.438-1.439h-7.342C65.659,80.801,65.011,81.449,65.011,82.24"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M65.011,75.262v2.883c0,0.791,0.648,1.439,1.438,1.439h7.342
      		c0.791,0,1.438-0.648,1.438-1.439v-2.883c0-0.789-0.647-1.438-1.438-1.438h-7.342C65.659,73.824,65.011,74.473,65.011,75.262"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M65.011,68.062v2.883c0,0.791,0.648,1.44,1.438,1.44h7.342
      		c0.791,0,1.438-0.649,1.438-1.44v-2.883c0-0.79-0.647-1.438-1.438-1.438h-7.342C65.659,66.625,65.011,67.272,65.011,68.062"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M65.011,61.001v2.883c0,0.791,0.648,1.438,1.438,1.438h7.342
      		c0.791,0,1.438-0.647,1.438-1.438v-2.883c0-0.79-0.647-1.438-1.438-1.438h-7.342C65.659,59.563,65.011,60.211,65.011,61.001"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M80.779,51.459l-1.117,1.934c0.672,0.352,1.324,0.735,1.949,1.156l1.115-1.935
      		C82.1,52.2,81.45,51.813,80.779,51.459"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M90.396,61.126c-0.35-0.672-0.73-1.324-1.143-1.954l-1.941,1.119
      		c0.417,0.629,0.796,1.282,1.145,1.955L90.396,61.126z"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M92.951,70.651h-2.242c0.017,0.336,0.027,0.676,0.027,1.017
      		c0,0.418-0.016,0.834-0.041,1.247h2.246c0.021-0.406,0.034-0.814,0.034-1.225C92.976,71.341,92.967,70.997,92.951,70.651"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M88.744,80.516c-0.326,0.684-0.693,1.344-1.09,1.984l1.958,1.133
      		c0.397-0.646,0.761-1.309,1.09-1.986L88.744,80.516z"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M88.45,54.725c0.339,0.396,0.668,0.801,0.985,1.219l2.199-1.923l1.348,1.542
      		l1.455-1.228c0.662-0.579,0.729-1.585,0.149-2.247l-1.628-1.863c-0.58-0.664-1.586-0.729-2.248-0.151l-1.456,1.228l1.347,1.542
      		L88.45,54.725z"
          />
          <path
            clipPath={`url(#batteria56vconstantpowerief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M97.229,71.689c0-14.085-10.799-25.691-24.553-26.984v3.597
      		c11.775,1.279,20.972,11.278,20.972,23.388c0,6.307-2.461,12.229-6.931,16.676l2.525,2.539
      		C94.393,85.777,97.229,78.955,97.229,71.689"
          />
        </g>
      </g>
    </IconBase>
  )
}

export default Batteria56VConstantPoweriEf
